import { Box } from '@mui/material';
import { ShebaField } from './sheba-field';

export const ShebaSearchField = (props: any) => {
    const { hideMaskPlaceholder = false, inputProps, ...restProps } = props;

    const handleChange = (maskedValue: string) => {
        const digits = maskedValue.replace(/\D/g, '').slice(0, 24);
        props?.onChange?.(digits ? `IR${digits}` : '');
    };

    return (
        <Box
            sx={{
                width: '100%',
                '& .MuiFormControl-root': {
                    width: '100%',
                },
                '& .MuiOutlinedInput-root': {
                    minHeight: 58,
                },
                '& .MuiInputBase-input': {
                    fontSize: '1rem',
                    py: 1.75,
                },
                '& .MuiInputAdornment-root .MuiTypography-root': {
                    fontSize: '1rem',
                    fontWeight: 700,
                },
            }}>
            <ShebaField
                {...restProps}
                inputProps={{
                    ...inputProps,
                    maskLazy: hideMaskPlaceholder,
                }}
                onChange={handleChange}
            />
        </Box>
    );
};
